import { MapboxGeoJSONFeature } from 'mapbox-gl'

const Tooltip = ({ feature }: { feature: MapboxGeoJSONFeature }) => {
  if (!feature || !feature.properties) {
    return null
  }
  return (
    <div id={`tooltip-${feature.properties.id}`}>
      <h4>{feature.properties.name}</h4>
      <p>
        {feature.properties.dates} – {feature.properties.style}
      </p>

      {feature.properties.topstars && (
        <p>
          <span>
            {feature.properties.topstars_label}
            {': '}
          </span>
          <b>{feature.properties.topstars}</b>
        </p>
      )}
      {feature.properties.expected_people && (
        <p>
          {'Public attendu: ' +
            feature.properties.expected_people +
            ' ' +
            feature.properties.expected_people_suffix}
        </p>
      )}
      <p>{feature.properties.location}</p>
      {feature.properties.website && (
        <p>
          <a
            href={feature.properties.website}
            target='_blank'
            rel='noreferrer'
          >
            {feature.properties.website && feature.properties.website.includes('facebook.com')
              ? 'Page Facebook'
              : 'Site Web'}
          </a>
        </p>
      )}
    </div>
  )
}

export default Tooltip
